/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".full-width[_ngcontent-%COMP%]{width:100%}\n/*# sourceMappingURL=forgot-password.component.css.map*/"];
export { styles as styles };
